const adUtil = {
  computed: {
    isVirtualBundleAd () {
      return this.ad.attributes['icon-type'] && this.ad.attributes['icon-type'] === 'virtual_bundle'
    }
  }
}

export { adUtil }
